import { createContext, useContext } from 'react';
import noop from 'lodash/noop';

export const BoardViewExperienceTrackerContext = createContext<{
	onExperienceSuccess?: () => void;
}>({
	onExperienceSuccess: noop,
});

export const useBoardViewExperienceTracker = () => {
	return useContext(BoardViewExperienceTrackerContext);
};
